export const CAREER = `{
  id
  photo_url
  title
  status
  category
}`
